<template>
  <grid-row>
    <grid-column :size="10">
      <form-field-select
        label="Select Follow Up Sequence Template"
        v-model="FUS_template_id"
        :validation-errors="validationErrors.FUS_template_id"
        @change.native="handleInput"
      >
        <option :value="null">Select a Template</option>
        <option v-for="template in fusTemplates"
          :key="`template-${template.id}`"
          :value="template.id"
          :disabled="!template.step_count"
        >{{ templateLabel(template) }}</option>
      </form-field-select>

      <p class="help-text" v-if="this.status">
        <icon-default icon="info" size="is-small is-secondary" />
        <i>The selected sequence has a default status "<strong>{{ this.status.label }}</strong>", but by using this sequence under status automation it will ignore the default status.</i>
      </p>
    </grid-column>
  </grid-row>
</template>

<script>
export default {
  name: "StatusAddToFollowUpSequenceAutomation",
  props: {
    value: null,
    validationErrors: {},
  },
  data() {
    return {
      FUS_template_id: null
    }
  },
  mounted() {
    this.FUS_template_id = this.value
  },
  computed: {
    fusTemplates() {
      return this.$store.getters.fusTemplates
    },
    fusTemplate() {
      const fusTemplate = this.fusTemplates.find(fusTemplate => fusTemplate.id === this.FUS_template_id)
      return (fusTemplate) ? fusTemplate : null
    },
    status() {
      if (!this.FUS_template_id || !this.fusTemplate) return null
      return this.$store.getters["pipeline/getStatusById"](this.fusTemplate.default_status_id)
    }
  },
  methods: {
    templateLabel(template) {
      if (template.step_count) return template.label

      return template.label + ' (needs steps before using)'
    },
    handleInput() {
      this.$emit('input', this.FUS_template_id);
      this.$emit('change', this.FUS_template_id);
    },
  }
}
</script>

<style scoped lang="scss">
.help-text {
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.3;
}
</style>
